// OGNI cart drawer: opens on the header Cart link, intercepts add-to-cart
// forms, and refreshes contents via the alternate cart template
// (templates/cart.ogni-drawer.liquid). Falls back to the normal cart page
// without JavaScript.

const drawer = document.querySelector('[data-ogni-drawer]');

if (drawer) {
  const urls = {
    cart: drawer.dataset.cartUrl,
    add: drawer.dataset.addUrl,
    change: drawer.dataset.changeUrl,
  };
  const root = drawer.querySelector('[data-ogni-cart-root]');
  const express = drawer.querySelector('[data-ogni-express]');
  let controller = null;

  const open = () => {
    if (drawer.open) return;
    drawer.showModal();
    requestAnimationFrame(() => drawer.classList.add('is-visible'));
  };

  const close = () => {
    drawer.classList.remove('is-visible');
    setTimeout(() => drawer.close(), 200);
  };

  const refresh = async () => {
    controller?.abort();
    controller = new AbortController();
    root.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(`${urls.cart}?view=ogni-drawer`, { signal: controller.signal });
      root.innerHTML = await response.text();
      const body = root.querySelector('[data-ogni-cart-body]');
      const count = body ? body.dataset.count : '0';
      document.querySelectorAll('[data-ogni-cart-count]').forEach((el) => {
        el.textContent = count;
      });
      if (express) express.hidden = count === '0';
      window.ogniRoastUpdate?.();
    } catch (error) {
      if (error.name !== 'AbortError') window.location.href = urls.cart;
    } finally {
      root.removeAttribute('aria-busy');
    }
  };

  const post = (url, body) =>
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-ogni-cart-open]');
    if (opener) {
      event.preventDefault();
      open();
      return;
    }
    if (event.target.closest('[data-ogni-cart-close]')) {
      close();
      return;
    }
    const lineButton = event.target.closest('[data-ogni-line]');
    if (lineButton && drawer.contains(lineButton)) {
      lineButton.disabled = true;
      post(`${urls.change}.js`, {
        line: Number(lineButton.dataset.ogniLine),
        quantity: Number(lineButton.dataset.ogniQty),
      }).then(refresh);
    }
  });

  // Click on the backdrop closes the drawer.
  drawer.addEventListener('click', (event) => {
    if (event.target === drawer) close();
  });

  drawer.addEventListener('cancel', (event) => {
    event.preventDefault();
    close();
  });

  // Intercept product forms that post to the cart.
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    const action = form.getAttribute('action') || '';
    if (!action.endsWith(urls.add) || form.hasAttribute('data-ogni-no-drawer')) return;
    if (event.submitter && event.submitter.name === 'checkout') return;
    event.preventDefault();
    const submit = form.querySelector('[type="submit"]');
    submit?.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(`${urls.add}.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      });
      if (!response.ok) {
        const data = await response.json();
        window.alert(data.description || data.message);
        return;
      }
      await refresh();
      open();
    } finally {
      submit?.removeAttribute('aria-busy');
    }
  });
}
